module.exports = __webpack_public_path__ + "img/527535531.bf608a44.jpg";